module.exports = __webpack_public_path__ + "img/L1.126ff53b.svg";